module.exports = __webpack_public_path__ + "static/images/icon-npsbox.43f2247.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edit/config/icon-npsbox.png
// module id = 02oo
// module chunks = 6 7